import { ParsedUrlQuery } from 'querystring';
import { castArray, map } from 'lodash';
import { slugToId, slugToString } from 'lib/utils/filterUtils';
import { CreatorSearchCriteria } from 'server/api/services/creatorSearch/types';

const QUERY_CRITERIA_MAP: { [key: string]: keyof CreatorSearchCriteria } = {
  role: 'byRoleId',
  users: 'byUserId',
  tags: 'tagValueId',
  events: 'eventValueId',
  byCollaboratorType: 'byCollaboratorTypeId',
  byCollaboratorRole: 'byCollaboratorRoleId',
  byCollaborator: 'byCollaboratorId',
  creatorStages: 'creatorStage',
  brands: 'brands',
  people: 'people',
  companies: 'companies',
  industries: 'industries',
  products: 'products',
};

export function queryToCriteria(query: ParsedUrlQuery) {
  return Object.keys(query).reduce(
    (acc, key) => {
      const criteriaKey = QUERY_CRITERIA_MAP[key] || key;
      const value = query[key];
      if (criteriaKey.includes('Id') || criteriaKey === 'creatorStage') {
        acc[criteriaKey] = map(castArray(value), (q: string) => slugToId(q));
      } else if (criteriaKey === 'near' || criteriaKey === 'geo') {
        acc[criteriaKey] = slugToString(value as string);
      } else if (criteriaKey === 'list') {
        acc[criteriaKey] = slugToString(value as string);
      } else if (criteriaKey === 'brands' || criteriaKey === 'people' || criteriaKey === 'companies' || criteriaKey === 'industries' || criteriaKey === 'products') {
        // These are string arrays, not ID arrays, so use slugToString
        acc[criteriaKey] = map(castArray(value), (q: string) => slugToString(q));
      } else {
        acc[criteriaKey] = query[key];
      }
      return acc;
    }, {} as any,
  );
}
